export const formatNumber = (num) => {
  const n = Number(num);
  if (!isFinite(n)) return '0.00';
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(n);
};

export const isBusinessDay = (date) => {
  const day = date.getDay();
  // Only block weekends (Saturday=6, Sunday=0)
  return day !== 0 && day !== 6;
};
